module.exports = __webpack_public_path__ + "static/media/20ECE3.5a9f6a8f.jpg";